<template>
    <form-view class="ar-detail-view">
        <veui-step v-if="store.steps.length" :steps="store.steps" :current="3" />
        <template slot="field">
            <veui-field name="aderName" field="aderName" label="广告主名称:">
                <veui-span>{{store.formData.aderName}}</veui-span>
            </veui-field>
            <veui-field name="name" field="name" label="服务名称:">
                <veui-span>{{store.formData.name}}</veui-span>
            </veui-field>
            <veui-field name="status" field="status" label="状态:">
                <veui-span :class="store.formData.statusInfo.cls" ref="status"
                >{{store.formData.statusInfo.text}}</veui-span>
                <veui-tooltip position="right" target="status" trigger="hover"
                >{{store.formData.comment}}</veui-tooltip>
            </veui-field>
            <veui-field
                label="审核意见:"
                name="rejectReason"
                field="rejectReason"
                v-if="store.formData.status === 'REJECT'">
                <veui-span>{{store.formData.comment}}</veui-span>
            </veui-field>
            <veui-field
                name="preview"
                field="preview"
                label="物料预览:"
                v-if="store.formData.previewCode">
                <veui-span>
                    请在appstore、百度手机助手或应用宝搜索下载AR预览工具dumix view， 安装后扫描下方二维码即可完成预览
                </veui-span>
            </veui-field>
            <veui-field name="qrcode" field="qrcode" v-if="store.formData.previewCode">
                <div class="img-container">
                    <img :src="store.formData.previewCode | https" alt="二维码图片"/>
                </div>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button v-if="canAudit" ui="primary" @click="submitAudit">提交审核</veui-button>
            <veui-button ui="aux" @click="copyService">复制物料</veui-button>
            <veui-button ui="aux" v-if="store.isTemplateType" @click="goBackToEdit">返回编辑</veui-button>
            <veui-button ui="aux" @click="back">返回</veui-button>
        </template>
    </form-view>
</template>
<script>

import {get, includes} from 'lodash';
import ARDetailModel from './ARDetailModel';
import FormView from '@baidu/ve-ria/views/FormView';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Span, Tooltip, Steps} from 'veui';

export default createView(FormView, ARDetailModel, {
    name: 'ARDetailModel',
    components: {
        'veui-step': Steps,
        'veui-span': Span,
        'veui-field': Field,
        'veui-button': Button,
        'veui-tooltip': Tooltip
    },
    computed: {
        prefix() {
            return this.store.isAdmin ? '' : '/app';
        },
        canAudit() {
            const status = get(this, 'store.formData.status', '');
            const previewCode = get(this, 'store.formData.previewCode', '');

            return previewCode && includes(['DRAFT', 'REJECT'], status);
        }
    },
    methods: {
        goBackToEdit() {
            const templateId = this.store.formData.templateId;
            const serviceId = this.store.getRouteParams().serviceId;
            this.global.redirect({
                url: `${this.prefix}/service/${serviceId}/ar/material/edit?from=edit&templateId=${templateId}`,
                type: 'push'
            });
        },
        async copyService() {
            const serviceId = this.store.getRouteParams().serviceId;
            if (this.store.isTemplateType) {
                this.global.redirect({
                    url: {
                        path: `${this.prefix}/service/${serviceId}/ar/copy?from=copy`
                    },
                    type: 'push'
                });
            }
            else {
                await this.store.copyService({
                    id: this.store.id
                });
                this.back();
            }
        },
        async submitAudit() {
            await this.store.submitAudit({
                id: this.store.id
            });
            this.back();
        }
    }
});
</script>
<style lang="less">
@import "~@/common/css/variables.less";
.ar-detail-view {
    .form-operation {
        margin-left: 0px;
    }

    .img-container {
        width: 120px;
        height: 120px;
        border-radius: 4px;
        vertical-align: bottom;
        border: 1px solid @muses-gray-2;

        img {
            width: 100%;
            height: 100%;
        }
    }
    .veui-steps-step {
        margin-right: 100px;

        &:after {
            width: 90px;
            right: -95px;
        }
    }
}
</style>


